import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { FaRegFolderOpen } from "react-icons/fa";
import { HiOutlineUserGroup } from "react-icons/hi";
import { BsCalendar } from "react-icons/bs";
import { useAuth } from "../../context/AuthContext";
import { collection, query, where, getDocs } from "firebase/firestore";
import { db } from "../../components/Auth/firebase";

function formatTimestamp(timestamp) {
  if (!timestamp) return "Unknown Date";
  const date = timestamp.seconds
    ? new Date(timestamp.seconds * 1000)
    : new Date(timestamp);
  return date.toLocaleDateString("en-US", {
    year: "numeric",
    month: "long",
    day: "numeric",
  });
}

function ProjectCard({ project }) {
  const navigate = useNavigate();
  const { currentUser } = useAuth();
  const [assigneesData, setAssigneesData] = useState([]);

  useEffect(() => {
    const fetchAssigneesData = async () => {
      const assigneesRef = collection(db, "users");
      const q = query(assigneesRef, where("uid", "in", project.assignees));
      const querySnapshot = await getDocs(q);
      const assignees = querySnapshot.docs.map((doc) => doc.data());
      setAssigneesData(assignees);
    };

    fetchAssigneesData();
  }, [project.assignees]);

  const handleClick = () => {
    navigate(`/projects/${project.id}`);
  };

  const isProjectLead = currentUser?.uid === project.creator?.uid;

  return (
    <div
      className="relative bg-white border border-gray-200 rounded-lg shadow-lg p-6 hover:shadow-2xl transform hover:scale-105 transition duration-300 ease-in-out cursor-pointer"
      onClick={handleClick}
    >
      <div className="flex items-center justify-between mb-4">
        <FaRegFolderOpen className="text-blue-500 text-2xl" />
        <span className="bg-[#9999ff] text-white text-sm font-medium px-2.5 py-0.5 rounded">
          {project.category || "Uncategorized"}
        </span>
      </div>
      <h2 className="text-xl font-bold text-gray-800 mb-2">{project.name}</h2>
      <p className="text-gray-600 mb-4">{project.description}</p>
      <div className="flex items-center space-x-4 mb-4">
        <div className="flex items-center">
          <HiOutlineUserGroup className="text-gray-500 mr-1" />
          <span className="text-sm text-gray-600">
            {project.assignees && Array.isArray(project.assignees)
              ? project.assignees.length
              : 0}{" "}
            Assignees
          </span>
        </div>
        <div className="flex items-center">
          <BsCalendar className="text-gray-500 mr-1" />
          <span className="text-sm text-gray-600">
            {formatTimestamp(project.createdAt)}
          </span>
        </div>
      </div>
      <div className="absolute bottom-0 left-0 flex space-x-[-10px] align-center">
        {assigneesData.map((assignee, index) => (
          <img
            key={index}
            src={assignee.profileImage || "https://via.placeholder.com/24"}
            alt={assignee.displayName}
            className={`w-6 h-6 ml-4 mb-2 rounded-full  shadow-md ${
              index > 0 ? "-ml-4" : ""
            }`}
          />
        ))}
      </div>
    </div>
  );
}

export default ProjectCard;
